import { BaseButton, ButtonLinkExternal } from "./components";

const Button = Object.assign(BaseButton, {
  LinkExternal: ButtonLinkExternal,
});

export { Button };
